jQuery(function ($) {
    const filterByTaxonomyModule = $('.module-layotterfilterbytaxonomy');
    const filterBtns = filterByTaxonomyModule.find('.category');
    const loadMoreBtn = $('.js-btn-load-more');
    const noPostsFound = $('#no-posts-found');

    filterBtns.on('click', function() {
        const btn = $(this);
        const categoryId = $(this).data('id');
        const teasers = $('.teaser-area').find('.teaser');
        filterBtns.not(btn).removeClass('active');

        if (btn.data('id') === 0) {
            // default show-all button
            btn.addClass('active');
            loadMoreBtn.removeClass('d-none'); 
            teasers.removeClass('hidden');
            noPostsFound.addClass('d-none');
        } else if (btn.hasClass('active')) {
            // button was active => set all to default
            btn.removeClass('active');
            filterBtns.eq(0).addClass('active');
            loadMoreBtn.removeClass('d-none'); 
            teasers.removeClass('hidden');
            noPostsFound.addClass('d-none');
        } else {
            // button was inactive => set active & filter teasers
            btn.addClass('active');
            loadMoreBtn.addClass('d-none');
            let teasersFound = false;

            teasers.each(function() {
                const teaser = $(this);
                
                if (teaser.find('.category[data-id="' + categoryId + '"]').length > 0) {
                    teaser.removeClass('hidden');
                    teasersFound = true;
                } else {
                    teaser.addClass('hidden');
                }
            });

            if (teasersFound) {
                noPostsFound.addClass('d-none');
            } else {
                noPostsFound.removeClass('d-none');
            }
        }
    });
});
